import gql from 'graphql-tag'

export const adminBillingTransactions = gql`
  query AdminBillingTransactions($limit: Int, $page: Int, $deviceId: Int, $status: String) {
    adminBillingTransactions(limit: $limit, page: $page, deviceId: $deviceId, status: $status) {
      transactions {
        id
        paygateTransactionId
        status
        amountInCents
        currency
        subscriptions {
          subscriptionId
          deviceId
          deviceName
        }
        createdAt
        updatedAt
        invoiceUrl
      }
      totalCount
      page
      totalPages
    }
  }
`
